import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import { GridColDef } from "@mui/x-data-grid";
import React, { useState } from "react";
import SearchButton from "../../components/Buttons/SearchButton";
import CommonPagination from "../../components/CustomPagination/CommonPagination";
import CommonTable from "../../components/CustomTable/CommonTable";
import { Title } from "../../components/Desc";
import strings from "../../config/localization";
import { useCreateRoleMutation, useGetRolesQuery } from "../../services/appln";
import { getRowsPerPage } from "../constants";
import { doesPermissionExist } from "../util";
import RoleDelete from "./RoleDelete";

export default function RolePanel() {
  const [count, setCount] = useState(1);
  const [rowPerPage, setRowPerPage] = useState(getRowsPerPage());
  const [searchTerm, setSearchTerm] = React.useState("");

  const getParams = {
    page: count,
    limit: rowPerPage,
    search: searchTerm,
  };

  const { data, error, isLoading, isFetching } = useGetRolesQuery(getParams);

  const [createRole, createRoleParams] = useCreateRoleMutation();

  const columns: GridColDef[] = [
    {
      field: "name",
      headerName: strings.name,
      width: 300,
    },
  ];

  if (doesPermissionExist("delete-role")) {
    columns.push({
      field: "delete",
      headerName: "",
      width: 150,
      renderCell: (params: any) =>
        params.row.protected ? null : <RoleDelete roleId={params.id} />,
    });
  }

  const handleChangePage = (event: any, value: any) => {
    setCount(value);
  };

  const handleChangeCount = (e: any) => {
    setRowPerPage(e.target.value);
  };

  return (
    <div>
      <Box sx={{ width: "100%" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            {isLoading || isFetching ? (
              <Backdrop
                sx={{
                  color: "#fff",
                  zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open
              >
                <CircularProgress color="inherit" />
              </Backdrop>
            ) : null}
          </Grid>
          {createRoleParams.isError ? (
            <Grid item xs={12}>
              <Alert severity="error">{strings.failedToCreateRole}</Alert>
            </Grid>
          ) : null}
          {error ? (
            <Grid item xs={12}>
              <Alert severity="error">
                <AlertTitle>{strings.error}</AlertTitle>
                {strings.failedToLoadRoles}
              </Alert>
            </Grid>
          ) : null}
          <Grid item xs={12}>
            <Grid container spacing={0}>
              <Grid item xs={12}>
                <Title text={strings.roles} />
              </Grid>
              {/* // disabling role create for now, for everyon. */}
              {/*doesPermissionExist("create-role") ?
                <>
                  { <Grid item xs={2}>
                    <NewButton onClickHandler={openNewRoleDialog} />
                    <NewRoleDialog title={strings.newRole} onSubmitHandler={closeNewRoleDialogAndCreateRole}
                      onCancelHandler={closeNewRoleDialog} state={newRoleDialogOpen} />
                  </Grid>
                  <Grid item xs={10}>
                    <SearchButton onClickHandler={(searchTerm: string) => { setSearchTerm(searchTerm) }} />
                  </Grid>
              </> : */}
              <Grid item xs={12}>
                <SearchButton
                  onClickHandler={(searchTerm: string) => {
                    setSearchTerm(searchTerm);
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <div>
              <CommonTable
                rows={data?.data ? data?.data : []}
                columns={columns}
                checkboxSelection={false}
              />
              <CommonPagination
                count={Math.ceil(data?.totalCount / rowPerPage)}
                page={count}
                handleChangePage={handleChangePage}
                rowPerPage={rowPerPage}
                handleChangeCount={handleChangeCount}
              />
            </div>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
